function PresentationChartLineIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.83333C2.5 4.26198 2.5 3.47631 2.98816 2.98816C3.47631 2.5 4.26198 2.5 5.83333 2.5H10H14.1667C15.738 2.5 16.5237 2.5 17.0118 2.98816C17.5 3.47631 17.5 4.26198 17.5 5.83333V8.33333V10.8333C17.5 12.4047 17.5 13.1903 17.0118 13.6785C16.5237 14.1667 15.738 14.1667 14.1667 14.1667H10H5.83333C4.26198 14.1667 3.47631 14.1667 2.98816 13.6785C2.5 13.1903 2.5 12.4047 2.5 10.8333V8.33333V5.83333Z"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 17.5026L9.6875 14.5859C9.84375 14.3776 10.1562 14.3776 10.3125 14.5859L12.5 17.5026"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83203 10.8359L8.00131 8.12434C8.54486 7.4449 9.60961 7.5577 9.9987 8.33594C10.3878 9.11419 11.4525 9.22694 11.9961 8.54752L14.1654 5.83594"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default PresentationChartLineIco;
